import { useEffect, useMemo, useState } from "react";
import { Notification, NotificationComponent } from "@shared/types";
import { sharedLib } from "@shared/services/shared.service";
import useDebouncedCallback from "@shared/utils/hooks/useDebouncedCallback";

const useNotificationsBanners = (sortedNotifications?: Notification[][]) => {
  const [isInitialized, setIsInitialized] = useState(false);

  const tradeIds = useMemo(
    () =>
      sortedNotifications
        ?.filter(
          (groupedNotification) =>
            groupedNotification?.[0].component_type ===
              NotificationComponent.TRADE ||
            groupedNotification?.[0].component_type ===
              NotificationComponent.ORDER
        )
        .map((groupedNotification) => groupedNotification?.[0].component_id),
    [sortedNotifications]
  );

  const [getShareTradeBannerImage, { data: tradesBanners }] =
    sharedLib.sharedApi.notifications.useLazyGetShareTradeBannerImageQuery();

  const getBannersImages = () => {
    if (tradeIds?.length) getShareTradeBannerImage({ trade_ids: tradeIds });
  };

  const getDebouncedShareTradeBannerImage = useDebouncedCallback({
    callback: getBannersImages,
    wait: 10000,
    trailing: true,
  });

  useEffect(() => {
    if (!isInitialized) {
      getBannersImages();
      setIsInitialized(true);
    } else {
      getDebouncedShareTradeBannerImage();
    }
  }, [tradeIds]);

  return tradesBanners;
};

export default useNotificationsBanners;
